<template>
  <main class="container">
    <PasswordScreen v-if="!loggedIn" @login="handleLogin" />
    <PersonalInfoScreen
      v-else
      :userData="userData"
      @logout="handleLogout"
    />
  </main>
</template>

<script>
import PasswordScreen from "./components/PasswordScreen.vue";
import PersonalInfoScreen from "./components/PersonalInfoScreen.vue";

export default {
  components: { PasswordScreen, PersonalInfoScreen },
  data() {
    return {
      loggedIn: false,
      userData: null,
    };
  },
  methods: {
    handleLogin(userData) {
      this.userData = userData;
      this.loggedIn = true;
    },
    handleLogout() {
      this.loggedIn = false;
      this.userData = null;
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 400px;
  margin: 5vh auto;
  padding: 0 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  text-align: center;
}

@media (max-width: 480px) {
  .container {
    margin-top: 8vh;
  }
}
</style>